import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import classNames from 'classnames';
import React,{Component} from 'react';
import DataMaintenanceForm from '../DataMaintenanceForm/DataMaintenanceForm';

import './UpdateDataMaintenance.css';

interface Props{
    data?: any

    onUpdate?: Function
}
interface State{
    updating: boolean

    // updates 
    updates: any
}

    // "product_type" jsonb,
    // "target_products" jsonb,
    // "nb_products" int,
    // "filters" jsonb,
    // "period" jsonb,
    // "aoi" jsonb,
    // "additional_requirements" jsonb,



export default class UpdateDataMaintenance extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            updating: false,
            updates:{ data:{ } }
        }
    }

    componentDidUpdate(prevProps:any){
        if(this.props.data !== prevProps.data){
            this.setState({ updates: { data: {} } })
        }
    }
    
    render(){
        return (
            <div className="update-data-maintenance">
                {/* <Optional>*Required</Optional> */}
                {/* <br/>
                <br/> */}

                <DataMaintenanceForm
                    updates={this.state.updates}
                    data_maintenance={this.props.data}
                    onChange={(updates:any, data?:boolean)=>{

                        this.setState({
                            updates: data ?
                                {
                                    ...this.state.updates,
                                    data:{
                                        ...this.state.updates.data,
                                        ...updates
                                    }
                                }
                            :
                                {
                                    ...this.state.updates,
                                    ...updates
                                }
                        });
                    }}
                />

                <br/>
                <br/>
                <div className="centered">
                    <div 
                        className={classNames({
                            "custom-button blue inline medium": true,
                            "disabled": this.state.updating
                        })}
                        onClick={this.update}
                    >
                        {
                            this.state.updating ? 
                            <Spinner height={15} white/>:
                            <><i className="fas fa-pen"/> UPDATE DATA MAINTENANCE</>
                        }

                    </div>
                </div>
            </div>
        );
    }


    update = async() =>{
        let { updates } = this.state;

        var body = new FormData();
        
        for(let attr of Object.keys(updates)){
            if(attr === 'data'){
                if(updates.data.description){
                    body.append('file', updates.data.description);
                }
                let data = { ...updates.data };
                delete data.description;
                body.append('data', JSON.stringify(data));
            }
            else
                body.append(attr, updates[attr]);
        }

        this.setState({ updating: true })
        try{
            let res = await request(`${API_URL}/api/v1/data_maintenances/${this.props.data.id}`,{
                method:'patch',
                data: body
            })

            this.props.onUpdate?.();

            create_toast({ type: 'success', message: `Successfully updated data maintenance ${res.data.value.data_id}` })

            // console.log("this.state", this.state);
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'update'
            })
            toast_request_error(e);
        }
        finally{
            this.setState({ updating: false })
        }
    }
};